import React from "react";

type Props = {
  open: boolean;
  message: string;
  email: string;
  password: string;
  busy: boolean;
  error: string | null;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onCancel: () => void;
  onContinueWithEmail: () => void;
  onContinueWithGoogle: () => void;
};

export default function MutationAuthModal({
  open,
  message,
  email,
  password,
  busy,
  error,
  onEmailChange,
  onPasswordChange,
  onCancel,
  onContinueWithEmail,
  onContinueWithGoogle,
}: Props) {
  if (!open) return null;

  return (
    <div className="proposal-modal-overlay">
      <div className="proposal-modal">
        <h2>Create your account to continue</h2>
        <p className="devplan-modal-copy">{message}</p>
        <input
          type="email"
          value={email}
          onChange={(event) => onEmailChange(event.target.value)}
          placeholder="you@company.com"
          className="devplan-contact-input"
          aria-label="Email for account signup"
          disabled={busy}
        />
        <input
          type="password"
          value={password}
          onChange={(event) => onPasswordChange(event.target.value)}
          placeholder="Create a password"
          className="devplan-contact-input"
          aria-label="Password for account signup"
          disabled={busy}
        />
        {error && <div className="error">{error}</div>}
        <div className="proposal-modal-actions">
          <button type="button" className="proposal-secondary-btn" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button type="button" onClick={onContinueWithEmail} disabled={busy}>
            {busy ? "Continuing…" : "Continue with Email"}
          </button>
        </div>
        <div className="devplan-auth-divider">or</div>
        <button
          type="button"
          className="proposal-secondary-btn devplan-google-signup-btn"
          onClick={onContinueWithGoogle}
          disabled={busy}
        >
          Continue with Google
        </button>
      </div>
    </div>
  );
}
